module.exports = __webpack_public_path__ + "static/media/white_logo_transparent_background.3c013ae9.svg";